import React from "react";
import ReactDOM from "react-dom/client";
// Icon tự host (class .bi-*); @font-face của font/icon nằm trong public/index.html
import "./styles/bootstrap-icons-subset.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import persistor, { store } from "./redux/store";
import { Provider } from "react-redux";
import { QueryClient, QueryClientProvider } from "react-query";
import { PersistGate } from "redux-persist/integration/react";

const root = ReactDOM.createRoot(document.getElementById("root"));

const queryClient = new QueryClient();

window.state = store;

// Theme antd (ConfigProvider) giờ bọc từng trang/popup tải lười — xem src/antdTheme.js + utils/themedLazy.js
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
